import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PhysicianInfoComponent } from './physician-info/physician-info.component';
import { IncomeInfoComponent } from './income-info/income-info.component';
import { ReviewInfoComponent } from './review-info/review-info.component';
import { EnrollmentRoutingModule } from './enrollment-routing.module';
import { EnrollmentComponent } from './enrollment/enrollment.component';
import { InsuranceInfoComponent } from './insurance-info/insurance-info.component';
import { PatientInfoComponent } from './patient-info/patient-info.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SignaturesComponent } from './signatures/signatures.component';
import { PortalModule } from '../../portal.module';
import { EnrollmentFormService } from '../../../../../services/EnrollmentFormService';


@NgModule({
  declarations: [
    PatientInfoComponent,
    PhysicianInfoComponent,
    IncomeInfoComponent,
    ReviewInfoComponent,
    EnrollmentComponent,
    InsuranceInfoComponent,
    PatientInfoComponent,
    SignaturesComponent
  ],
  imports: [
    CommonModule,
    PortalModule,
    EnrollmentRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatGridListModule,
    MatCardModule,
    MatMenuModule,
    MatIconModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatCheckboxModule,
  ],
  providers: [EnrollmentFormService],
  bootstrap: [EnrollmentComponent]
})
export class EnrollmentModule { }
